import { StyleSheet } from "react-native";
import { theme } from "../../../../theme";
export const styles = StyleSheet.create({
    default: {
        borderRadius: theme.spacing.xsmall2,
        paddingVertical: theme.spacing.medium,
        backgroundColor: theme.colors.greyscale.lightest,
    },
    placeholderImage: {
        alignItems: "center",
    },
    label: {
        alignSelf: "center",
        color: theme.colors.greyscale.light,
        textAlign: "center",
    },
    list: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginBottom: theme.spacing.xsmall,
        justifyContent: "center",
    },
    imageContainer: {
        position: "relative",
        paddingHorizontal: theme.spacing.xsmall2,
    },
    image: {
        width: theme.spacing.xlarge3,
        height: theme.spacing.xlarge3,
        borderRadius: theme.spacing.xlarge3,
        marginBottom: theme.spacing.xsmall2,
    },
    smallThumbnail: {
        width: theme.spacing.xlarge2,
        height: theme.spacing.xlarge2,
    },
    icon: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 0,
        bottom: 0,
        backgroundColor: theme.colors.light.base,
        width: theme.spacing.large,
        height: theme.spacing.large,
        borderRadius: theme.spacing.large,
        zIndex: 2,
    },
    smallIcon: {
        width: theme.spacing.medium,
        height: theme.spacing.medium,
    },
    placeholderIconContainer: {
        opacity: 0.25,
    },
    androidModalStyles: {
        paddingHorizontal: theme.spacing.xsmall2,
    },
    iosModalStyles: {
        paddingHorizontal: theme.spacing.xsmall,
    },
    buttonImage: {
        resizeMode: "contain",
        alignSelf: "center",
    },
    buttonText: {
        ...theme.fontDefaults.base,
        fontFamily: "ProximaSemiBold",
        color: theme.colors.light.base,
    },
    container: {
        flex: 1,
    },
    backAndFinishButton: {
        backgroundColor: theme.colors.brand.base,
        borderRadius: theme.spacing.large,
    },
    assetContainerDefault: {
        flex: 1,
        paddingTop: theme.spacing.small,
    },
    androidAssetContainer: {
        marginTop: -theme.spacing.xlarge2,
    },
});
//# sourceMappingURL=InputImage.styles.js.map